import {setupListPaymentsReconcile} from '../../common/list-payments';
import {runOnce} from '../../common/run-once';
import {documentReady} from '../../document-ready';

runOnce('helper-list-payments', () => {
    documentReady().then(() => {
        setupListPaymentsReconcile();
    });
});
